import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL;

class InformeService {

    saveNouInforme(nouInforme) {
        return axios.post(API_URL + 'gesbeques/informe', {
            ...nouInforme,
            idInforme: nouInforme.id
        }, {
            headers: authHeader()
        });
    }

    fillNouInforme(nouInforme) {
        return axios.post(API_URL + 'gesbeques/fill-informe', {
            ...nouInforme,
            idInforme: nouInforme.id
        }, {
            headers: authHeader()
        });
    }

    getInformes(idCentre) {
        return axios.post(API_URL + 'gesbeques/get-informes', {
            idCentre
        }, {
            headers: authHeader()
        });
    }

    getMeusCentres() {
        return axios.post(API_URL + 'gesbeques/get-meus-centres', {}, {
            headers: authHeader()
        });
    }

    getInforme(idInforme) {
        return axios.post(API_URL + 'gesbeques/get-informe', {
            idInforme
        }, {
            headers: authHeader()
        });
    }

    saveInforme(informe) {
        return axios.post(API_URL + 'gesbeques/save-informe', {
            informe,
            idInforme: informe.id
        }, {
            headers: authHeader()
        });
    }
    enviarCCB(idInforme) {
        return axios.post(API_URL + 'gesbeques/enviar-ccb', {
            idInforme
        }, {
            headers: authHeader()
        });
    }
    eliminarInforme(idInforme) {
        return axios.post(API_URL + 'gesbeques/del-informe', {
            idInforme
        }, {
            headers: authHeader()
        });
    }
    getCentre(idCentre, idInforme = null) {
        return axios.post(API_URL + 'gesbeques/get-centre', {
            idCentre,
            idInforme
        }, {
            headers: authHeader()
        });
    }
    uploadFile(formData) {
        return axios.post(API_URL + 'gesbeques/upload-informe', formData, {
            headers: authHeader(true)
        });
    }
    logoutSession() {
        localStorage.removeItem('user')
        localStorage.removeItem('access_token')
    }
}

export default new InformeService();